// extracted by mini-css-extract-plugin
export default {"TermsOfService":"TermsOfService_TermsOfService__7JNhQ","TermsOfService_ContentContainer":"TermsOfService_TermsOfService_ContentContainer__q9GxB"};